import React, { CSSProperties } from "react";
import { Form } from "react-bootstrap";

type Props = {
  options: { title: string; value: string }[];
  value?: string | null | undefined;
  ref?: unknown | null | undefined;
  as: "select";
  custom?: boolean | null | undefined;
  multiple?: boolean | null | undefined;
  disabled?: boolean | null | undefined;
  htmlSize?: number | null | undefined;
  id?: string | null | undefined;
  name?: string | null | undefined;
  isInvalid?: boolean | null | undefined;
  isValid?: boolean | null | undefined;
  onChange?: ((e) => void) | null | undefined;
  plaintext?: boolean | null | undefined;
  readOnly?: boolean | null | undefined;
  size?: ("sm" | "lg") | null | undefined;
  type?: string | null | undefined;
  bsPrefix?: "form-control" | null | undefined;
  bsCustomPrefix?: string | null | undefined;
  style?: CSSProperties | null | undefined;
  className?: (string | string) | null | undefined;
};

function FormSelect(__props: Props) {
  const options = __props["options"];

  return React.createElement(
    Form.Control,
    __props,
    options
      ? options.map((item) =>
          React.createElement(
            "option",
            {
              value: item.value,
            },
            item.title
          )
        )
      : null
  );
}

export default FormSelect;
